// extracted by mini-css-extract-plugin
export default {"limitHeight":"Account_limitHeight__1uQO+","widthLimit":"Account_widthLimit__dDjci"};